import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { initializeConsentMode } from "./utils/scriptLoader";

// NOTE: IMPORT STYLES
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "antd/dist/reset.css";
import "./index.css";

// NOTE: IMPORT REDUX
import { Provider } from "react-redux";
import store, { persistor } from "./store";

// NOTE: IMPORT TOAST NOTIFICATIONS
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// NOTE: IMPORT FONTS
import "@fontsource/public-sans";
import "@fontsource/public-sans/100.css";
import "@fontsource/public-sans/300.css";
import "@fontsource/public-sans/500.css";
import "@fontsource/public-sans/700.css";
import "@fontsource/public-sans/900.css";
import "@fontsource/poppins/600.css";

import { LanguageProvider } from "./contexts/LanguageContext";
import { ConsentProvider } from "./contexts/ConsentContext";
import CookieBanner from "./components/Popups/CookieBanner";
import { PersistGate } from "redux-persist/integration/react";

// Establish Google Consent Mode v2 DENIED defaults immediately on page load,
// BEFORE GTM loads or GA4 fires any tags. This ensures _ga and other analytics
// cookies are NOT written until the user explicitly accepts analytics cookies.
// Mirrors the agreed consent-gating approach used for Meta Pixel.
initializeConsentMode();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LanguageProvider>
        <ConsentProvider>
          <App />
          <CookieBanner />
        </ConsentProvider>
        <ToastContainer
          autoClose={3000}
          theme="dark"
          closeOnClick
          position="top-right"
          style={{ zIndex: 99999 }}
        />
      </LanguageProvider>
    </PersistGate>
  </Provider>,
);
